import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-cooked-bread/react-cooked-bread/packages/docs/src/components/layout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "extend",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#extend",
        "aria-label": "extend permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Extend`}</h1>
    <h2 {...{
      "id": "components",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#components",
        "aria-label": "components permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Components`}</h2>
    <p>{`Perhaps most commonly, you'll want to use your own component. This library can be easily integrated into your own component library.`}</p>
    <pre {...{
      "className": "language-tsx"
    }}><code parentName="pre" {...{
        "className": "language-tsx"
      }}><span parentName="code" {...{
          "className": "token tag"
        }}><span parentName="span" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`<`}</span><span parentName="span" {...{
              "className": "token class-name"
            }}>{`ToastProvider`}</span></span>{`
  `}<span parentName="span" {...{
            "className": "token attr-name"
          }}>{`container`}</span><span parentName="span" {...{
            "className": "token script language-javascript"
          }}><span parentName="span" {...{
              "className": "token script-punctuation punctuation"
            }}>{`=`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`MySpecialOverlay`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{`
  `}<span parentName="span" {...{
            "className": "token attr-name"
          }}>{`toastRoot`}</span><span parentName="span" {...{
            "className": "token script language-javascript"
          }}><span parentName="span" {...{
              "className": "token script-punctuation punctuation"
            }}>{`=`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`FancySlideAnimation`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{`
  `}<span parentName="span" {...{
            "className": "token attr-name"
          }}>{`toastContent`}</span><span parentName="span" {...{
            "className": "token script language-javascript"
          }}><span parentName="span" {...{
              "className": "token script-punctuation punctuation"
            }}>{`=`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`OurCompanyMessageBox`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{`
`}<span parentName="span" {...{
            "className": "token punctuation"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token plain-text"
        }}>{`
`}</span></code></pre>
    <h3 {...{
      "id": "default-components",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#default-components",
        "aria-label": "default components permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Default Components`}</h3>
    <p>{`Discovering how the default components work can help you determine when and how to extend these components. We're working on additional default components for toast-root (animation wrapper) and toast-content (look and feel).`}</p>
    <h4 {...{
      "id": "toastcontainer",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#toastcontainer",
        "aria-label": "toastcontainer permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h4" {...{
        "href": "https://github.com/brettinternet/react-cooked-bread/blob/master/packages/react-cooked-bread/src/container.tsx"
      }}>{`ToastContainer`}</a></h4>
    <p>{`This is always rendered by the `}<a parentName="p" {...{
        "href": "/react-cooked-bread/provider"
      }}>{`ToastProvider`}</a>{` and positions the toasts according to the defined placement. There is a child `}<inlineCode parentName="p">{`div`}</inlineCode>{` that is rendered by this wrapper which is from the `}<inlineCode parentName="p">{`React-Transition-Group`}</inlineCode>{` parent.`}</p>
    <h5 {...{
      "id": "props",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h5" {...{
        "href": "#props",
        "aria-label": "props permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Props`}</h5>
    <pre {...{
      "className": "language-ts"
    }}><code parentName="pre" {...{
        "className": "language-ts"
      }}><span parentName="code" {...{
          "className": "token keyword"
        }}>{`interface`}</span>{` `}<span parentName="code" {...{
          "className": "token class-name"
        }}>{`ContainerProps`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
  hasToasts`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  placement`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`PlacementOption`}</span>{`
  styler`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ContainerStyler`}</span>{`
  onMouseEnter`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token parameter"
        }}>{`ev`}<span parentName="span" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`MouseEvent`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`HTMLElement`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
  onMouseLeave`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token parameter"
        }}>{`ev`}<span parentName="span" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`MouseEvent`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`HTMLElement`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`
`}</code></pre>
    <h4 {...{
      "id": "toastroot",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#toastroot",
        "aria-label": "toastroot permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h4" {...{
        "href": "https://github.com/brettinternet/react-cooked-bread/blob/master/packages/react-cooked-bread/src/toast-root"
      }}>{`ToastRoot`}</a></h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/reactjs/react-transition-group"
      }}>{`React-Trasition-Group`}</a>{` animates the render of each toast and applies the styles to this element. For unique enter/exit styles, recreate this component and pass it to the `}<inlineCode parentName="p">{`ToastProvider`}</inlineCode>{`.`}</p>
    <h5 {...{
      "id": "props-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h5" {...{
        "href": "#props-1",
        "aria-label": "props 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Props`}</h5>
    <pre {...{
      "className": "language-ts"
    }}><code parentName="pre" {...{
        "className": "language-ts"
      }}><span parentName="code" {...{
          "className": "token keyword"
        }}>{`interface`}</span>{` `}<span parentName="code" {...{
          "className": "token class-name"
        }}>{`ToastRootProps`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
  content`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ReactNode`}</span>{`
  autoDismiss`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  timeout`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`number`}</span>{`
  `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`type`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastTypeOption`}</span>{`
  placement`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`PlacementOption`}</span>{`
  transitionDuration`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`TransitionDuration`}</span>{`
  transitionState`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`TransitionStatus`}</span>{`
  id`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`string`}</span>{`
  title`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`string`}</span>{`
  subtitle`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`string`}</span>{`
  isRunning`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  `}<span parentName="code" {...{
          "className": "token function-variable function"
        }}>{`onDismiss`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
  `}<span parentName="code" {...{
          "className": "token function-variable function"
        }}>{`onMouseEnter`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token parameter"
        }}>{`ev`}<span parentName="span" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`MouseEvent`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`HTMLElement`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
  `}<span parentName="code" {...{
          "className": "token function-variable function"
        }}>{`onMouseLeave`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token parameter"
        }}>{`ev`}<span parentName="span" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`MouseEvent`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`HTMLElement`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
  styles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`CSSProperties`}</span>{`
`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`
`}</code></pre>
    <h4 {...{
      "id": "toastcontent",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#toastcontent",
        "aria-label": "toastcontent permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h4" {...{
        "href": "https://github.com/brettinternet/react-cooked-bread/blob/master/packages/react-cooked-bread/src/toast-content"
      }}>{`ToastContent`}</a></h4>
    <p>{`Custom React elements make up the stylized toast within this component: icons, buttons, text wrappers, the animated bar when `}<inlineCode parentName="p">{`autoDismiss`}</inlineCode>{` is enabled.`}</p>
    <h5 {...{
      "id": "props-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h5" {...{
        "href": "#props-2",
        "aria-label": "props 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Props`}</h5>
    <pre {...{
      "className": "language-ts"
    }}><code parentName="pre" {...{
        "className": "language-ts"
      }}><span parentName="code" {...{
          "className": "token keyword"
        }}>{`interface`}</span>{` `}<span parentName="code" {...{
          "className": "token class-name"
        }}>{`ToastContentProps`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
  content`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ReactNode`}</span>{`
  autoDismiss`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  timeout`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`number`}</span>{`
  `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`type`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastTypeOption`}</span>{`
  placement`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`PlacementOption`}</span>{`
  transitionDuration`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`TransitionDuration`}</span>{`
  transitionState`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`TransitionStatus`}</span>{`
  id`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`string`}</span>{`
  title`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`string`}</span>{`
  subtitle`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`string`}</span>{`
  isRunning`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  `}<span parentName="code" {...{
          "className": "token function-variable function"
        }}>{`onDismiss`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
  `}<span parentName="code" {...{
          "className": "token function-variable function"
        }}>{`onMouseEnter`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token parameter"
        }}>{`ev`}<span parentName="span" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`MouseEvent`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`HTMLElement`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
  `}<span parentName="code" {...{
          "className": "token function-variable function"
        }}>{`onMouseLeave`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token parameter"
        }}>{`ev`}<span parentName="span" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`MouseEvent`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`HTMLElement`}</span><span parentName="span" {...{
            "className": "token operator"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`void`}</span>{`
  styles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`StylesObj`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`<`}</span><span parentName="code" {...{
          "className": "token keyword"
        }}>{`keyof`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`typeof`}</span>{` classNames`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`>`}</span>{`
`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`

## `}<span parentName="code" {...{
          "className": "token constant"
        }}>{`CSS`}</span>{`

`}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`You`}</span>{` may choose to use the `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`default`}</span>{` components and modify the `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`default`}</span>{` styles`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`.`}</span>{` `}<span parentName="code" {...{
          "className": "token property-access"
        }}><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`Stylers`}</span></span>{` are passed to the different styles props on the `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`[`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastProvider`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`]`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`/`}</span>{`provider`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token template-string"
        }}><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span><span parentName="span" {...{
            "className": "token string"
          }}>{`containerStyles`}</span><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{` `}<span parentName="code" {...{
          "className": "token template-string"
        }}><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span><span parentName="span" {...{
            "className": "token string"
          }}>{`transitionGroupStyles`}</span><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{` `}<span parentName="code" {...{
          "className": "token template-string"
        }}><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span><span parentName="span" {...{
            "className": "token string"
          }}>{`toastStyles`}</span><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`.`}</span>{`

### `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`Stylers`}</span>{`

`}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`This`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`is`}</span>{` the recommended way to custom styles `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`for`}</span>{` existing components`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`.`}</span>{`

`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`>`}</span>{` `}<span parentName="code" {...{
          "className": "token constant"
        }}>{`A`}</span>{` `}<span parentName="code" {...{
          "className": "token template-string"
        }}><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span><span parentName="span" {...{
            "className": "token string"
          }}>{`Styler`}</span><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span></span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`is`}</span>{` an _object_ or a _function_ `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`with`}</span>{` prop arguments that returns an object`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`.`}</span>{`

#### `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`Style`}</span>{` object

`}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`With`}</span>{` a `}<span parentName="code" {...{
          "className": "token template-string"
        }}><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span><span parentName="span" {...{
            "className": "token string"
          }}>{`React.CSSProperties`}</span><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span></span>{` style object`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{`

`}<span parentName="code" {...{
          "className": "token template-string"
        }}><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span><span parentName="span" {...{
            "className": "token template-punctuation string"
          }}>{`\``}</span></span>{`\`tsx
`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`<`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastProvider`}</span>{`
  containerStyles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`=`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
    padding`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token string"
        }}>{`'1rem'`}</span>{`
  `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`
  `}<span parentName="code" {...{
          "className": "token comment"
        }}>{`// the toastContentStyles prop is unique because it styles multiple components`}</span>{`
  toastContentStyles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`=`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
    wrapper`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
      backgroundColor`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token string"
        }}>{`'hotpink'`}</span>{`
    `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{`
    text`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
      color`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token string"
        }}>{`'dodgerblue'`}</span>{`
    `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`
  `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`
`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`>`}</span>{`
`}</code></pre>
    <h4 {...{
      "id": "style-function",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#style-function",
        "aria-label": "style function permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Style function`}</h4>
    <p>{`Or a function that receives an argument with props for that components, that returns a `}<inlineCode parentName="p">{`React.CSSProperties`}</inlineCode>{` style object:`}</p>
    <pre {...{
      "className": "language-tsx"
    }}><code parentName="pre" {...{
        "className": "language-tsx"
      }}><span parentName="code" {...{
          "className": "token tag"
        }}><span parentName="span" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`<`}</span><span parentName="span" {...{
              "className": "token class-name"
            }}>{`ToastProvider`}</span></span>{`
  `}<span parentName="span" {...{
            "className": "token attr-name"
          }}>{`containerStyles`}</span><span parentName="span" {...{
            "className": "token script language-javascript"
          }}><span parentName="span" {...{
              "className": "token script-punctuation punctuation"
            }}>{`=`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="span" {...{
              "className": "token parameter"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{` hasToasts `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{` `}<span parentName="span" {...{
              "className": "token arrow operator"
            }}>{`=>`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
    backgroundColor`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` hasToasts `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`?`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'hotpink'`}</span>{` `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'transparent'`}</span>{`
  `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`)`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{`
  `}<span parentName="span" {...{
            "className": "token attr-name"
          }}>{`toastContentStyles`}</span><span parentName="span" {...{
            "className": "token script language-javascript"
          }}><span parentName="span" {...{
              "className": "token script-punctuation punctuation"
            }}>{`=`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="span" {...{
              "className": "token parameter"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{` isRunning `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{` `}<span parentName="span" {...{
              "className": "token arrow operator"
            }}>{`=>`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
    wrapper`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
      backgroundColor`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token keyword"
            }}>{`type`}</span>{` `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`===`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'error'`}</span>{` `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`?`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'tomato'`}</span>{` `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'mediumseagreen'`}</span>{`
    `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{`
    progress`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
      animationPlayState`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` isRunning `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`?`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'running'`}</span>{` `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'paused'`}</span>{`
    `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span>{`
  `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`)`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{`
  `}<span parentName="span" {...{
            "className": "token attr-name"
          }}>{`transitionGroupStyles`}</span><span parentName="span" {...{
            "className": "token script language-javascript"
          }}><span parentName="span" {...{
              "className": "token script-punctuation punctuation"
            }}>{`=`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
    display`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'flex'`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{`
    justifyContent`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`'space-between'`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{`
  `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{`
`}<span parentName="span" {...{
            "className": "token punctuation"
          }}>{`>`}</span></span><span parentName="code" {...{
          "className": "token plain-text"
        }}>{`
`}</span></code></pre>
    <p>{`Then, `}<a parentName="p" {...{
        "href": "https://github.com/emotion-js/emotion"
      }}>{`Emotion`}</a>{` creates those styles into CSS classes assigned to the element.`}</p>
    <h3 {...{
      "id": "classes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#classes",
        "aria-label": "classes permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Classes`}</h3>
    <p>{`There are only two components rendered to the DOM. The first is the container that holds all the toasts in an absolute position over the viewport. Next is the toast component which is made up of just a few elements. Here they are:`}</p>
    <pre {...{
      "className": "language-sass"
    }}><code parentName="pre" {...{
        "className": "language-sass"
      }}><span parentName="code" {...{
          "className": "token selector"
        }}>{`.react-cooked-bread__container`}</span>{`
  `}<span parentName="code" {...{
          "className": "token selector"
        }}>{`.react-cooked-bread__toast__transition-group`}</span>{`
    `}<span parentName="code" {...{
          "className": "token selector"
        }}>{`.react-cooked-bread__toast__root`}</span>{`
      `}<span parentName="code" {...{
          "className": "token selector"
        }}>{`.react-cooked-bread__toast__wrapper`}</span>{`
        `}<span parentName="code" {...{
          "className": "token comment"
        }}>{`// other classes depend on which toastContent component you choose`}</span>{`
        `}<span parentName="code" {...{
          "className": "token comment"
        }}>{`// classnames are declared at the top of each component file`}</span>{`
`}</code></pre>
    <h2 {...{
      "id": "accessibility",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#accessibility",
        "aria-label": "accessibility permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Accessibility`}</h2>
    <p>{`A note on accessibility from `}<a parentName="p" {...{
        "href": "https://getbootstrap.com/docs/4.3/components/toasts/#accessibility"
      }}>{`Bootstrap`}</a>{`:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Toasts are intended to be small interruptions to your visitors or users, so to help those with screen readers and similar assistive technologies, you should wrap your toasts in an `}<inlineCode parentName="p">{`aria-live`}</inlineCode>{` region. Changes to live regions (such as injecting/updating a toast component) are automatically announced by screen readers without needing to move the user’s focus or otherwise interrupt the user. Additionally, include aria-atomic="true" to ensure that the entire toast is always announced as a single (atomic) unit, rather than announcing what was changed (which could lead to problems if you only update part of the toast’s content, or if displaying the same toast content at a later point in time).`}</p>
      <p parentName="blockquote">{`Note that the live region needs to be present in the markup before the toast is generated or updated. If you dynamically generate both at the same time and inject them into the page, they will generally not be announced by assistive technologies.`}</p>
      <p parentName="blockquote">{`You also need to adapt the `}<inlineCode parentName="p">{`role`}</inlineCode>{` and `}<inlineCode parentName="p">{`aria-live`}</inlineCode>{` level depending on the content. If it’s an important message like an error, use `}<inlineCode parentName="p">{`role="alert" aria-live="assertive"`}</inlineCode>{`, otherwise use `}<inlineCode parentName="p">{`role="status" aria-live="polite"`}</inlineCode>{` attributes.`}</p>
      <p parentName="blockquote">{`As the content you’re displaying changes, be sure to update the delay timeout to ensure people have enough time to read the toast.`}</p>
    </blockquote>
    <p>{`When using `}<inlineCode parentName="p">{`autoDismiss: false`}</inlineCode>{`, you must add a close button to allow users to dismiss the toast.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      